<template>
    <li :class="['element-tree__file', { 'is--selected': selected }]" @click="select">
         <svg :class="['element-icon', 'element-icon--asset-' + iconName]" width="1em" height="1em"><use :href="['/img/icons.svg#icon-asset-' + iconName]"></use></svg>
        <span :title="file.name" class="element-tree__file-name app-vertical-navigation__submenu-item-title">{{ file.name }}</span>
        <!-- <span class="ml-auto web-font" v-if="selected">&bullet;</span> -->
    </li>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
    props: {
        file: {
            type: Object,
            default: () => new Object()
        }
    },
    data () {
        return { }
    },
    computed: {
        ...mapState('assets', {
            selectedId: state => state.selectedId
        }),
        selected () {
            return this.selectedId === this.file.id
        },
        iconName () {
            return this.file.type
        }
    },
    methods: {
        async select () {
            await this.$store.dispatch('assets/selectFile', this.file.id)
        }
    }
}
</script>
